import React, { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"

import OdpdFooter from "./OdnFooter"
import { TextField } from "components"
import classes from "./index.module.scss"

const initialFormState = { note: "" }

const OrderDetailsNote = props => {
  const { order, setOrders } = props

  const [t] = useTranslation()

  const [enableEdit, setEnableEdit] = useState(false)
  const [form, setForm] = useState(initialFormState)

  const inputRef = useRef(null)

  const handleOrderNote = (e) => {
    const value = e.target.value

    setForm(prev => ({ ...prev, note: value }))
  }

  const autoFocus = () => {
    if (!enableEdit) return

    inputRef.current.focus()
  }

  useEffect(() => {
    autoFocus()
  }, [enableEdit])

  useEffect(() => {
    order.orderStatus !== "pending" &&
      setEnableEdit(false)
  }, [order.orderStatus])

  const showOrderNote =
    !enableEdit && !!order.note

  const showEditButton =
    order.orderStatus === "pending"

  const hide =
    !order.note &&
    order.orderStatus !== "pending"

  if (hide) return null

  return (
    <div className={classes["container"]}>
      <span className={classes["title"]}>
        {t("توضیحات_سفارش")}
      </span>

      {
        showOrderNote &&
        <div className={classes["note"]}>
          {order.note}
        </div>
      }

      {
        enableEdit &&
        <TextField
          label=""
          ref={inputRef}
          componentClass="textarea"
          maxLength={300}
          value={form.note}
          className={classes["input"]}
          onChange={handleOrderNote}
        />
      }

      {
        showEditButton &&
        <OdpdFooter
          form={form}
          setForm={setForm}
          order={order}
          setOrders={setOrders}
          enableEdit={enableEdit}
          setEnableEdit={setEnableEdit}
        />
      }
    </div >
  )
}

export default OrderDetailsNote